import { Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const PaymentSecurityInfo = ({
  paymentTextRef,
  selectedValue
}: {
  paymentTextRef: React.RefObject<HTMLDivElement>;
  selectedValue?: string;
}) => {
  return (
    <>
      <Box
        ref={paymentTextRef}
        sx={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '24px',
          marginBottom: '4px'
        }}
      >
        <img
          src="/static/images/icons/lock.svg"
          alt="SEOSpace"
          height={'18px'}
          width={'18px'}
        />
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '24px',
            textAlign: 'center',
            color: 'var(--color-primary)'
          }}
          className='text-sm'
        >
          {'Secured by Stripe'}
        </Typography>
        <CloseIcon
          sx={{
            fontSize: '18px',
            color: 'var(--color-primary)',
            marginLeft: '16px'
          }}
        />
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '24px',
            textAlign: 'center',
            color: 'var(--color-primary)'
          }}
        >
          {'Cancel anytime'}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontSize: { xs: '12px', md: '14px' },
          fontWeight: 400,
          lineHeight: '24px',
          textAlign: 'center',
          color: 'var(--color-primary)',
          paddingX: '16px'
        }}
      >
        {`A quick temporary hold (up to 50% of your plan) may appear to verify your card, but it's released within seconds.`}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontSize: { xs: '12px', md: '14px' },
          fontWeight: 400,
          lineHeight: '24px',
          textAlign: 'center',
          color: 'var(--color-primary)',
          paddingX: '16px'
        }}
      >
        {`Your card will be charged for ${
          selectedValue === 'annually' || selectedValue === 'yearly'
            ? 'yearly'
            : selectedValue === 'monthly'
            ? 'monthly'
            : 'monthly/yearly'
        } subscription at the end of 7-day trial period.`}
      </Typography>
    </>
  );
};
